<button
  type="button"
  (click)="open()"
  class="rounded-lg border border-[#1E2A78] px-4 py-2 text-sm font-medium text-[#1E2A78] transition hover:bg-indigo-50"
>
  {{ 'EXCEL_UPLOAD.FILE_UPLOAD' | translate }}
</button>

<app-popup
  [(show)]="showPopup"
  [type]="'custom'"
  title="EXCEL_UPLOAD.FILE_UPLOAD"
  width="w-full max-w-lg min-w-[300px]"
>
  @if (showPopup) {
    <div class="space-y-3">
      <label class="block text-sm font-medium text-gray-700">
        {{ 'EXCEL_UPLOAD.SELECT_FILE' | translate }}
      </label>

      <input
        #fileUploadInput
        type="file"
        accept=".xlsx,.xls"
        (change)="onFileSelected($event)"
        class="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
      />

      @if (selectedFileName) {
        <p class="text-xs text-gray-500">{{ 'EXCEL_UPLOAD.SELECTED' | translate: { name: selectedFileName } }}</p>
      }

      @if (popupError) {
        <p class="text-xs font-medium text-red-600">{{ popupError | translate }}</p>
      }
    </div>

    <div
      class="-mx-6 sm:-mx-8 mt-6 flex flex-col justify-end gap-3 border-t px-6 pt-4 sm:flex-row sm:gap-6 sm:px-8"
    >
      <button
        type="button"
        class="btn-primary"
        [disabled]="isImporting"
        [class.opacity-50]="isImporting"
        [class.cursor-not-allowed]="isImporting"
        (click)="onSave(fileUploadInput)"
      >
        {{ (isImporting ? 'EXCEL_UPLOAD.IMPORTING' : 'COMMON.SAVE') | translate }}
      </button>

      <button
        type="button"
        class="btn-danger"
        [disabled]="isImporting"
        [class.opacity-50]="isImporting"
        [class.cursor-not-allowed]="isImporting"
        (click)="close()"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  }
</app-popup>
